export const Archive = 'archive'
export const InWork = 'inWork'
export const Missing = 'missing'
export const ReportCreated = 'reportCreated'
export const Validation = 'validation'
export const Validated = 'validated'
export const Sent = 'sent'